export type Gender = 'home' | 'dona' | 'no_binari' | 'no_contesta_genere';

export enum GenderEnum {
  home = 'Home',
  dona = 'Dona',
  no_binari = 'No binari',
  no_contesta_genere = 'No té l’obligació de contestar i no ho fa',
}
